
export default function About() {
  return (
    <section id="about" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid md:grid-cols-2 gap-16 items-center">
          {/* Left: Image */}
          <div className="relative">
            <div className="relative rounded-3xl overflow-hidden shadow-2xl w-full h-full">
              <img 
                src="https://public.readdy.ai/ai/img_res/edf6c789e4ca3c312320734fabbd2dfc.jpg"
                alt="サポート提供者"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>

          {/* Right: Content */}
          <div>
            <div className="inline-block px-4 py-2 bg-[#FF9B8A]/10 rounded-full mb-6">
              <span className="text-[#FF9B8A] text-sm font-medium">About Me</span>
            </div>

            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6" style={{ fontFamily: "'Klee One', cursive" }}>
              こんなあなたへ
            </h2>

            <div className="space-y-6 mb-8">
              <div className="flex items-start gap-4">
                <div className="w-10 h-10 bg-[#FFD93D]/20 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-heart-pulse-line text-[#FF9B8A] text-xl w-5 h-5 flex items-center justify-center"></i>
                </div>
                <div>
                  <h3 className="font-bold text-gray-900 mb-2">食事や体型についての気持ちのモヤモヤ</h3>
                  <p className="text-gray-600 text-sm leading-relaxed">
                    食事や体型についての気持ちのモヤモヤや不安。私も同じ経験をしました。その複雑な気持ち、よくわかります。
                    <br /><span className="text-xs text-gray-500">※治療・指導・改善方法の提案は行いません</span>
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="w-10 h-10 bg-[#FFD93D]/20 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-refresh-line text-[#FF9B8A] text-xl w-5 h-5 flex items-center justify-center"></i>
                </div>
                <div>
                  <h3 className="font-bold text-gray-900 mb-2">同じ考えが頭から離れないことによる日常的な困り感</h3>
                  <p className="text-gray-600 text-sm leading-relaxed">
                    同じ考えが頭から離れない、安心するための行動が止められない。繰り返してしまう自分を責めないでください。
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="w-10 h-10 bg-[#FFD93D]/20 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-parent-line text-[#FF9B8A] text-xl w-5 h-5 flex items-center justify-center"></i>
                </div>
                <div>
                  <h3 className="font-bold text-gray-900 mb-2">親との関係にモヤモヤしている</h3>
                  <p className="text-gray-600 text-sm leading-relaxed">
                    親のことは好きなのに、なぜかイライラしてしまう。わかってほしいのに伝わらない。そんな複雑な気持ち、一緒に整理しましょう。
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="w-10 h-10 bg-[#FFD93D]/20 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-chat-heart-line text-[#FF9B8A] text-xl w-5 h-5 flex items-center justify-center"></i>
                </div>
                <div>
                  <h3 className="font-bold text-gray-900 mb-2">毎日の小さな不安を相談したい</h3>
                  <p className="text-gray-600 text-sm leading-relaxed">
                    親に理解されない気持ち、今日あったちょっと嫌だったこと。小さな悩みも、あなたにとっては大切なこと。一緒に話しましょう。
                  </p>
                </div>
              </div>
            </div>

            <div className="bg-gradient-to-br from-[#FFF5F3] to-[#F0F9FF] rounded-2xl p-6 border-2 border-[#FF9B8A]/20">
              <p className="text-gray-700 leading-relaxed mb-4">
                <strong className="text-[#FF9B8A]">心理学を専攻する大学生</strong>として、同じ経験をした者として、あなたの気持ちに寄り添います。
              </p>
              <p className="text-sm text-gray-600 mb-3">
                ※ 本サービスは医療行為・心理療法ではありません。日常的な悩みの傾聴・対話サポートを目的としています。
              </p>
              <p className="text-xs text-gray-500">
                <strong>重要：</strong>保護者同意があっても、提供者が適切でないと判断した場合、セッションをお断り・中断することがあります。
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
